// extracted by mini-css-extract-plugin
module.exports = {"title":"antd-pro-pages-profile-basic-style-title"};